import PropTypes from "prop-types"
import { map } from "lodash"
import Panel from "../panel"
import { FACTOR } from "../../shapes"
import { Row } from "../rows"

function ScorecardDecompositionSummary({ selectedFactors }) {
  if (!selectedFactors.length) {
    return null
  }

  return <Panel fixed>
    {map(selectedFactors, ({ id, label, original, rebalanced, delta, formatter }) =>
      <Row key={id} {...{ id, label, original, rebalanced, delta, formatter }} />,
    )}
  </Panel>
}

ScorecardDecompositionSummary.propTypes = {
  selectedFactors: PropTypes.arrayOf(FACTOR).isRequired,
  formatter: PropTypes.func,
}

export default ScorecardDecompositionSummary
